import { Box, CardContent, CardHeader, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import React from 'react';

interface PostInsights {
    post_impressions: number;
    post_impressions_unique: number;
    post_clicks: number;
    reactions: number;
    created_time: string;
    message: string;
    id: string;
    engagementRate: string;
    full_picture: string;
    likes: string;
    comments: string;
}

interface PostCardProps {
    post: PostInsights;
}

interface FBPostInsightsProps {
    postWiseInsights?: PostInsights[] | null;
}

const FBPostInsights: React.FC<FBPostInsightsProps> = ({ postWiseInsights }) => {


    return (
        <Card sx={{ maxWidth: '90%', margin: '0 auto', mt: 10, mb: 2 }}>
            <CardHeader title={"Posts"}>
            </CardHeader>
            <CardContent>
                {postWiseInsights?.map(post => <PostCard post={post} key={post.id} />)}
            </CardContent>
        </Card>
    )
}


const PostCard: React.FC<PostCardProps> = ({ post }) => {

    const formatTime = (time: string) => {
        const date = new Date(time);
        const options: Intl.DateTimeFormatOptions = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        return date.toLocaleString('en-US', options);
    }

    return (
        <Box sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: '5px', display: 'flex' }}>
            <Box sx={{ mr: 2, width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', borderRadius: '5px' }}>
                {post.full_picture ?
                    <img src={post.full_picture} alt="post" style={{ borderRadius: '5px', maxWidth: '100%', maxHeight: '100%' }} /> :
                    <Typography variant="body2" color="textSecondary">No Picture</Typography>
                }
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography variant="body1" sx={{ mb: 1 }}>{post.message}</Typography>
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={4}><Typography variant="body2">Impressions: {post.post_impressions}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Reach: {post.post_impressions_unique}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Clicks: {post.post_clicks}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Reactions: {post.reactions}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Engagement Rate: {post.engagementRate} %</Typography></Grid>
                </Grid>
                <Typography variant="body2" color="textSecondary">{formatTime(post.created_time)}</Typography>
            </Box>
        </Box>
    );
}
export default FBPostInsights;